module.exports = __webpack_public_path__ + "static/media/fise.5e390b08.svg";